/**
 * Public surface of ``src/lib/analytics``.
 *
 * The only thing call sites need from this module is
 * ``captureEvent`` and the ``Event`` type. The schemas, registry,
 * verb whitelist, and forbidden-property list are internal — exposed
 * here for tests and the monthly audit script, not for production
 * call sites.
 *
 * IMPORTANT: this module is one of the two sanctioned places that
 * may import ``posthog-js`` directly (the other is
 * ``src/lib/observability/``). The ESLint
 * ``no-restricted-imports`` rule enforces this — outside these two
 * paths, capture flows go through ``captureEvent``.
 */

export { captureEvent, EVENT_NAME_PATTERN } from "./capture";
export { useCaptureOnce } from "./use-capture-once";
export { APP_VERSION, UI_VERSION, standardBody } from "./standard-body";
export type { Event, ParsedEvent } from "./registry";
export { EventSchema, ALL_EVENT_SCHEMAS } from "./registry";
export {
  ALLOWED_VERBS,
  isAllowedVerb,
  type AllowedVerb,
} from "./governance/verbs";
export {
  FORBIDDEN_PROPERTY_PATTERNS,
  isForbiddenProperty,
  type ForbiddenPattern,
} from "./governance/forbidden";
